import {
  ORGCHART_REQUEST_DATA,
  ORGCHART_REQUEST_DATA_SUCCESS,
  ORGCHART_REQUEST_DATA_FAILURE,
  ORGCHART_SET_ACTIVE_NODE,
} from '../constants/ActionTypes';


const initialState = {
  isFetching: false,
  error: false,
};

export default function EmployeeOrgChart(state = initialState, action) {
  switch (action.type) {
    case ORGCHART_REQUEST_DATA:
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case ORGCHART_REQUEST_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data,
      };
    case ORGCHART_REQUEST_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case ORGCHART_SET_ACTIVE_NODE: {
      return {
        ...state,
        cursorItem: action.nodeId,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/EmployeeOrgChart.js